import * as fromDatatype from '../datatype-library/index';

export class bl_fi_packing_order_packed_bins_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  packing_order_hdr_guid: fromDatatype.GuidDataFieldInterface;
  bin_hdr_guid: fromDatatype.GuidDataFieldInterface;
  bin_line_guid: fromDatatype.GuidDataFieldInterface;
  packed_container_qty: fromDatatype.NumericDatatypeInterface;
  packed_base_qty: fromDatatype.NumericDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_packing_order_packed_bins_RowClass implements bl_fi_packing_order_packed_bins_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  packing_order_hdr_guid: fromDatatype.GuidDataFieldInterface;
  bin_hdr_guid: fromDatatype.GuidDataFieldInterface;
  bin_line_guid: fromDatatype.GuidDataFieldInterface;
  packed_container_qty: fromDatatype.NumericDatatypeInterface;
  packed_base_qty: fromDatatype.NumericDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}